import metal1Img from "../assets/images/allproducts/metal1.png";
import metal2Img from "../assets/images/allproducts/metal2.png";
import metal3Img from "../assets/images/allproducts/metal3.png";

const sharedStandards = [
  "IRQ Metal Profiles are produced in accordance with ASTM C645 and ASTM C955 standards.",
  "Galvanized sheet steel complies with ASTM A653, ASTM C1047 requirements",
  "For detailed installation and storage guidelines, refer to ASTM C1280 and ASTM C754.",
];

const sharedSectionDimensions = [
  { label: "Core type", value: "Type C" },
  { label: "Width - Nominal", value: "1,200 mm" },
  { label: "Length - Standard", value: "2,400 mm, 3,000 mm" },
  { label: "Weight - Nominal", value: "6.192kg/m2" },
];

const sharedDimensionsTable = [
  {
    role: "RQ-CB-125-25",
    h1: "25",
    width: "12.5",
    thickness: "0.45",
    length: "300",
    zincCoating: "G40 - G90",
  },
  {
    role: "RQ-CB-125-25",
    h1: "25",
    width: "12.5",
    thickness: "0.45",
    length: "300",
    zincCoating: "G40 - G90",
  },
  {
    role: "RQ-CB-125-25",
    h1: "25",
    width: "12.5",
    thickness: "0.45",
    length: "300",
    zincCoating: "G40 - G90",
  },
  {
    role: "RQ-CB-125-25",
    h1: "25",
    width: "12.5",
    thickness: "0.45",
    length: "300",
    zincCoating: "G40 - G90",
  },
  {
    role: "RQ-CB-125-25",
    h1: "25",
    width: "12.5",
    thickness: "0.45",
    length: "300",
    zincCoating: "G40 - G90",
  },
  {
    role: "RQ-CB-125-25",
    h1: "25",
    width: "12.5",
    thickness: "0.45",
    length: "300",
    zincCoating: "G40 - G90",
  },
];

export const metalDetailById = {
  metal1: {
    id: "metal1",
    heroTag: "ACCESSORIES",
    heroTitle: "Casing Bead",
    heroDescription:
      "A casing bead is a metal edge trim for gypsum boards that protects exposed ends and creates a clean, straight finish at ceiling or wall terminations.",
    heroImage: metal1Img,
    standards: sharedStandards,
    materialProperties: [
      { label: "Steel Thickness", value: "0.45 mm" },
      { label: "Galvanization", value: "G40-G90 Zinc coating" },
      { label: "Yield stress, Fy 270 Mpa ; Ultimate stress, Fu 330 Mpa", value: "" },
    ],
    sectionDimensions: sharedSectionDimensions,
    dimensionsTable: sharedDimensionsTable,
  },
  metal2: {
    id: "metal2",
    heroTag: "ACCESSORIES",
    heroTitle: "Ceiling metal frame",
    heroDescription:
      "CD60 Channels are precision-formed, galvanized lightweight steel sections designed for use as primary (main) and secondary channels in suspended ceiling systems. Manufactured from highquality galvanized steel, they offer excellent corrosion resistance, long-term durability, and consistent performance in both commercial and residential applications.",
    heroImage: metal2Img,
    standards: sharedStandards,
    materialProperties: [
      { label: "Steel Thickness", value: "0.45 mm" },
      { label: "Galvanization", value: "G40-G90 Zinc coating" },
      { label: "Yield stress, Fy 270 Mpa ; Ultimate stress, Fu 330 Mpa", value: "" },
    ],
    sectionDimensions: sharedSectionDimensions,
    dimensionsTable: sharedDimensionsTable,
  },
  metal3: {
    id: "metal3",
    heroTag: "ACCESSORIES",
    heroTitle: "Ceiling metal frame",
    heroDescription:
      "Deflection fire track designed with an offset shoulder to correspond with the gypsum board thickness.",
    heroDescriptionMore:
      " The secondary gypsum layer is positioned flush with the slab underside and secured to the shoulder. Intended for use in fire-rated wall systems to allow vertical deflection.",
    heroBullets: [
      "Deflection fire track designed with an offset shoulder to correspond with the gypsum board thickness",
      "The secondary gypsum layer is positioned flush with the slab underside and secured to the shoulder.",
      "Intended for use in fire-rated wall systems to allow vertical deflection.",
    ],
    heroImage: metal3Img,
    standards: sharedStandards,
    materialProperties: [
      { label: "Steel Thickness Range", value: "0.9mm - 1.5mm" },
      { label: "Galvanization", value: "G40-G90 Zinc coating" },
      { label: "Yield stress, Fy 270 Mpa ; Ultimate stress, Fu 330 Mpa", value: "" },
    ],
    sectionDimensions: sharedSectionDimensions,
    dimensionsTable: sharedDimensionsTable,
  },
};

export function getMetalDetailById(id) {
  if (!id) return undefined;
  return metalDetailById[id];
}
